// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2gl6Q","options":"AnswerScale_options__1MvlW","selected":"AnswerScale_selected__3iiDI"};